import { TracingSamplingRuleActionTypes } from '@logz-pkg/enums';
// OTEL rules => Configuration
const isRuleAllServices = rule => typeof rule.and === 'undefined';
const isServiceRule = rule => rule.string_attribute?.key === 'service.name';
const getActionTypeAndValue = (rule) => {
    if (!!rule.latency) {
        return {
            type: TracingSamplingRuleActionTypes.KeepLatencyThreshold,
            value: rule.latency.threshold_ms,
        };
    }
    else if (!!rule.probabilistic) {
        return {
            type: TracingSamplingRuleActionTypes.KeepPercentageOfTraces,
            value: rule.probabilistic.sampling_percentage,
        };
    }
    else if (!!rule.status_code) {
        return {
            type: TracingSamplingRuleActionTypes.KeepFailed,
        };
    }
    throw new Error(`Unsupported rule format${JSON.stringify(rule)}`);
};
export const transformOtelRulesToConfigRules = (rules, disabledRules) => {
    const tracingConfigRules = rules.map((rule, index) => {
        if (isRuleAllServices(rule)) {
            return {
                isDisabled: disabledRules.includes(index),
                index,
                action: getActionTypeAndValue(rule),
                services: [],
            };
        }
        const { and: { and_sub_policy: subPolicies }, } = rule;
        const { action, services } = subPolicies.reduce((acc, cur) => {
            if (isServiceRule(cur)) {
                return { ...acc, services: cur.string_attribute.values };
            }
            return { ...acc, action: getActionTypeAndValue(cur) };
        }, { action: null, services: null });
        return {
            isDisabled: disabledRules.includes(index),
            services,
            action,
            index,
        };
    });
    return tracingConfigRules;
};
// Configuration => OTEL Rules
const getActionRule = (baseRuleName, action) => ({
    [TracingSamplingRuleActionTypes.KeepLatencyThreshold]: {
        name: `${baseRuleName}-latency`,
        type: 'latency',
        latency: {
            threshold_ms: action.value,
        },
    },
    [TracingSamplingRuleActionTypes.KeepPercentageOfTraces]: {
        name: `${baseRuleName}-probabilistic`,
        type: 'probabilistic',
        probabilistic: {
            hash_salt: 'custom-salt',
            sampling_percentage: action.value,
        },
    },
    [TracingSamplingRuleActionTypes.KeepFailed]: {
        name: `${baseRuleName}-status_code`,
        type: 'status_code',
        status_code: {
            status_codes: ['ERROR'],
        },
    },
}[action.type]);
const getServiceNameRule = (baseRuleName, services) => ({
    name: `${baseRuleName}-string_attribute`,
    type: 'string_attribute',
    string_attribute: {
        key: 'service.name',
        values: services,
    },
});
const generateSubRules = (baseRuleName, { action, services }) => [
    getServiceNameRule(baseRuleName, services),
    getActionRule(baseRuleName, action),
];
export const transformConfigRulesToOtelRules = (configRules) => configRules.map((configRule, index) => {
    const baseRuleName = `${configRule.action.type}-${configRule.action.value ?? ''}-${index}`;
    if (configRule.services?.length === 0) {
        return getActionRule(baseRuleName, configRule.action);
    }
    return {
        name: baseRuleName,
        type: 'and',
        and: {
            and_sub_policy: generateSubRules(baseRuleName, configRule),
        },
    };
});
export const getDisabledRulesIndexes = (samplingRules) => samplingRules.reduce((acc, rule, index) => {
    if (rule.isDisabled) {
        acc.push(index);
    }
    return acc;
}, []);
//# sourceMappingURL=sampling-rules.manipulator.js.map